// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bic_ss","PhotoTitleEditForm__cancelBtn":"iy_b bic_sw bic_sv"};